module.exports = __webpack_public_path__ + "img/icons/new/globe-pb-556e6825b61d94c4e1d97ce419454ec9.svg";